import api from "../../api";
import {AxiosResponse} from "axios";
import {OtherCompanyModuleServiceInterface} from "../../types";
import {BaseAddResponse, BaseEditResponse} from "../../types/response";
import {OtherCompanyAddRequest, OtherCompanyEditRequest, OtherCompanyListRequest, OtherCompanyPrepareEditFormRequest, OtherCompanyViewRequest} from "../../types/modules/otherCompanu/request";
import {OtherCompanyListResponse, OtherCompanyPrepareAddFormResponse, OtherCompanyPrepareEditFormResponse, OtherCompanyViewResponse} from "../../types/modules/otherCompanu/response";

export class OtherCompanyService implements OtherCompanyModuleServiceInterface {
    public list(request: OtherCompanyListRequest): Promise<AxiosResponse<OtherCompanyListResponse>> {
        return api.get('/company_administration/other_company/', { params: request });
    }
    public edit(request: OtherCompanyEditRequest): Promise<AxiosResponse<BaseEditResponse>> {
        return api.put(`/company_administration/other_company/${request.id}/edit`, request);
    }
    public view(request: OtherCompanyViewRequest): Promise<AxiosResponse<OtherCompanyViewResponse>> {
        return api.get(`/company_administration/other_company/${request.id}/view`);
    }
    public add(request: OtherCompanyAddRequest): Promise<AxiosResponse<BaseAddResponse>> {
        return api.post(`/company_administration/other_company/add`, request);
    }
    public prepareEditForm(request: OtherCompanyPrepareEditFormRequest): Promise<AxiosResponse<OtherCompanyPrepareEditFormResponse>> {
        return api.get(`/company_administration/other_company/${request.id}/prepare_edit`);
    }
    public prepareAddForm(): Promise<AxiosResponse<OtherCompanyPrepareAddFormResponse>> {
        return api.get(`/company_administration/other_company/prepare_add`);
    }
}